import { call, fork, put, takeEvery } from "typed-redux-saga";
import { getAppServerClient } from "@advosys/component-app-server-client-js";
import { BackendAccessActionTypes, backendActions } from "./backend-access-store";
function* getClientIdentity() {
    const apiResult = yield* call(getAppServerClient().common.statusV2.getClientIdentityAsync);
    if (apiResult.ok) {
        yield* put(backendActions.getClientIdentitySuccess(apiResult.data));
    }
    else {
        yield* put(backendActions.getClientIdentityFail(apiResult.error));
    }
}
function* watchGetClientIdentityRequest() {
    yield* takeEvery(BackendAccessActionTypes.GetClientIdentityRequest, getClientIdentity);
}
export const backendAccessSagaInit = () => [fork(watchGetClientIdentityRequest)];
